<template>
    <div id="defaultId1">
        <!-- 作者：luoyiming
          时间：2019-10-26
          描述：菜品管理-菜品编辑-基础信息 -->
        <div id="idH2th7O" class="basic-setting-content pl16 pr16 u7E3HKf">
            <!-- 基本信息 -->
            <div id="idNdO1Cu" class="common-form">{{ $t('基本信息') }}</div>
            <el-form-item id="idD39aGz" :label="$t('菜品名称')" :rules="[{ required: true, message: $t('请填写菜品名称') }]"
                prop="model.product_name">
                <el-input id="id6Xvdg1" v-model="form.model.product_name" class="max-w460"
                    @blur="validateProductName"></el-input>
                <mi-free-time v-if="form.model.IsShowAICompletion">
                    <el-button id="id8EApwh" @click="onDishInformation" size="small" type="warning" :loading="loading">
                        {{ $t('AI魔法创建') }}
                    </el-button>
                </mi-free-time>
                <div class="wenhao-box">
                    <el-tooltip class="item" effect="light" :content="$t('通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。')"
                        placement="top-start">
                        <span class="wenhao">?</span>
                    </el-tooltip>
                </div>
            </el-form-item>
            <el-form-item id="idD39aGz" :label="$t('口味')" :rules="[{ required: true, message: $t('请填写口味') }]"
                prop="model.taste">
                <el-input id="id6Xvdg1" v-model="form.model.taste" class="max-w460">
                </el-input>
            </el-form-item>
            <el-form-item id="id5oxfug" :label="$t('所属分类')" :rules="[{ required: true, message: $t('你选择菜品分类') }]"
                prop="model.category_id">
                <el-select id="id2UnOSb" v-model="form.model.category_id">
                    <template id="id6Em25h">
                        <el-option id="idpvxran" v-for="(cat, index) in categoryList" :value="cat.category_id" :key="index"
                            :label="cat.name">
                        </el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item id="idQdQ8ch" :label="$t('菜品图片')" :rules="[{ required: true, message: $t('请上传菜品图片') }]"
                prop="model.image">
                <div class="yulantu" v-if="form.model.image.length == 0">
                    <img src="@/assets/img/yulantu.png">
                    <el-button style="display: inline-block" size="small" type="primary" @click="openAiBox">
                        {{ $t('从AI图库中选择') }}
                    </el-button>
                    <el-button style="display: inline-block" size="small" type="primary" @click="openProductUpload">
                        {{ $t('请上传菜品图片') }}
                    </el-button>
                </div>
                <div id="idUF8LGW" class="draggable-list" v-else>
                    <draggable id="idGVxXT8" v-model="form.model.image" class="wrapper           ">
                        <transition-group id="idfNq4N4">
                            <div id="idXTfATS" v-for="(item, index) in form.model.image" class="item" :key="index + item">
                                <img id="id2qTTU7" v-img-url="item.file_path" />
                                <a id="idvRmGgP" class="delete-btn" href="javascript:void(0);"
                                    @click.stop="deleteImg(index)">
                                    <i id="idWmBGmd" class="el-icon-close">
                                    </i>
                                </a>
                            </div>
                        </transition-group>
                    </draggable>
                    <div id="idkVAiDJ" style="position: relative;top: 85px;left:0px">
                        <el-button style="display: inline-block" size="small" type="primary" @click="openAiBox">
                            {{ $t('从AI图库中选择') }}
                        </el-button>
                        <el-button style="display: inline-block" size="small" type="primary" @click="openProductUpload">
                            {{ $t('请上传菜品图片') }}
                        </el-button>
                    </div>
                </div>
            </el-form-item>
            <div class="ai-image-container" v-if="isShowAiSearch">
                <div class="title-input-search">
                    <div style="flex: 1"></div>
                    <span class="ai-pictures-title">{{ $t('AI图库') }}</span>
                    <el-input class="ai_search max-w460" v-model="ai_search" @blur="getAiImageList(2)"
                        placeholder="从AI图库搜索">
                        <template slot="suffix">
                            <i class="el-icon-search fangdajing" @click="getAiImageList(2)"></i>
                        </template>
                    </el-input>
                </div>
                <div class="ai-image-list">
                    <div v-if="aliImageList.length != 0">
                        <div class="imagelists" @scroll="loadMore">
                            <div v-for="(item, index) in aliImageList" class="aliImageItem" :key="index + item"
                                @click="selectFileFunc(item, index)">
                                <div v-if="item.selected" class="selectedIcon"><i class="el-icon-check duigou"></i>
                                </div>
                                <img v-img-url="item.food_url" />
                            </div>
                        </div>
                        <div style="margin-top: 12px;text-align: center;">
                            <el-button size="small" type="primary" @click="confirmAiImageSelect">{{ $t('确认使用') }}</el-button>
                        </div>
                    </div>
                    <div class="no-have-image" v-else>
                        <img src="@/assets/img/kulian.svg" width="117">
                        <p>{{ $t('AI未识别到您的菜品图片') }}</p>
                        <p>{{ $t('可在搜索框') }}<span>{{ $t('更换菜品名称') }}</span>~</p>
                    </div>
                    <!-- 这里添加你的图片列表代码 -->
                </div>
            </div>
            <el-form-item id="idNkZrFm" :label="$t('菜品卖点')">
                <el-input id="idqWWjfX" v-model="form.model.selling_point" class="max-w460           " type="textarea">
                </el-input>

                <mi-free-time>
                    <el-button id="id8EApwh" @click="onSellingPoint" size="small" type="warning"
                        :loading="selling_point_loading">{{ $t('换一换') }}
                    </el-button>
                </mi-free-time>
            </el-form-item>
            <!-- 菜品图片组件 -->
            <Upload id="idJRGef8" v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
                :isAspectRatio="false" @returnImgs="returnProductImgsFunc">{{ $t('上传图片') }}
            </Upload>
            <el-form-item id="c794d1" class="uEXwDSa" :label="$t('配料')" :rules="[{ required: true, message: '' }]" prop>
                <div id="idhhQjkh">
                    <el-button id="id8sjR97" @click="addItem">{{ $t('添加项') }}
                    </el-button>
                    <el-button id="idjvA9Wx" @click="removeItem">{{ $t('删除项') }}
                    </el-button>
                    <el-row id="idfszXiq">
                        <el-col id="idfqh68V" v-for="item in form.model.ingredient" class="uiNJkJ4" :span="6"
                            :key="item.id">
                            <el-input id="idGiAMPz" v-model="item.ingredient_name" class="uBgpnls uBuIHG1"
                                :disabled="item.ingredient_id > 0 ? true : false">
                            </el-input>
                            <el-button id="idOSzPuv" @click="deleteItem(item.ingredient_name)" class="   uFZHTog"
                                icon="el-icon-close">
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form-item>
            <el-form-item :label="$t('标签')">
                <mi-free-time>
                    <el-button @click="getTagAction" size="small" type="warning" :loading="getTagLoading">{{ $t('AI获取标签') }}
                    </el-button>
                    <el-tooltip class="item" effect="light" :content="$t('添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求')" placement="top-start">
                        <span class="wenhao">?</span>
                    </el-tooltip>
                </mi-free-time>
                <el-checkbox-group v-model="form.model.tag">
                    <el-checkbox v-for="(option, index) in form.model.tag" :key="index" :label="option">{{
                        option
                    }}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </div>
    </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';

export default {
    components: {
        Upload,
        draggable
    },
    data() {
        return {
            ai_search: '',
            ai_search_type: 0,
            selectedOptions: [], // 用于存储选中的选项
            size: 'medium',
            loading: false,
            getTagLoading: false,
            formData: {},
            isProductUpload: false,
            selling_point_loading: false,//菜品卖点状态
            isShowWenHao: false,
            // 分类下拉
            categoryList: [],
            aliImageList: [],
            itemsPerScroll: 0,
            showImageList: [],
            page: 1,
            isShowAiSearch: false,
        };
    },
    props: {
        activeName: {
            type: String,
            default: 'chinese'
        },
        product_type: {
            type: Number,
            default: 0
        }
    },
    inject: ['form'],
    watch: {
        ai_search(newVal, oldVal) {
            if (newVal) {
                this.getAiImageList(2);
            } else {
                this.getAiImageList(1);
            }
        },
        'activeName': {
            handler() {
                this.categoryLabel()
            },
        },
        'formData.category': {
            handler() {
                this.categoryLabel()
            },
            deep: true
        }
    },
    created() {
        this.$set(this, 'formData', this.form);
    },
    methods: {
        //选择的ai图库确认操作
        confirmAiImageSelect() {
            const selectedItems = this.aliImageList.filter(item => item.selected);
            const selectedIds = selectedItems.map(item => item.id);
            const selectedIdsStr = selectedIds.join(',');
            PorductApi.set_ai_image_file({ 'params': selectedIdsStr }, true).then(res => {
                if (res.code == 1) {
                    this.form.model.image = []
                    this.$set(this.form.model, 'image', res.data.file_list);
                }
            })
        },
        //ai图库的列表选择操作
        selectFileFunc(item, index) {
            // 检查当前点击的图片是否已经被选中
            let alreadySelected = item.selected;
            // 遍历文件列表，将所有文件的 selected 属性设置为 false
            this.aliImageList.forEach((file) => {
                file.selected = false;
            });
            // 如果当前点击的图片之前没有被选中，那么将其设置为选中状态
            if (!alreadySelected) {
                this.aliImageList[index].selected = true;
            }
        },

        fetchMoreImages() {
            this.page += 1;
            // 在加载更多图片时，增加 page 的值
            if (this.ai_search_type == 0) {
                this.getAiImageList(1, this.page);  // 你可能需要根据你的具体需求修改这里的参数
            }
            if (this.ai_search_type == 1) {
                this.getAiImageList(2, this.page);  // 你可能需要根据你的具体需求修改这里的参数
            }
        },

        getAiImageList(type, page = 1) {
            let foodName
            if (type == 1) {
                this.ai_search_type = 0
                foodName = this.form.model.product_name
            }
            if (type == 2) {
                this.ai_search_type = 1
                foodName = this.ai_search
            }

            console.log(foodName)
            PorductApi.get_ai_image_list(foodName, page, true).then(res => {
                console.log(res)
                // 如果是加载更多图片，将新加载的图片添加到 aliImageList 的末尾
                // 否则，用新加载的图片替换现有的图片
                if (page > 1) {
                    this.aliImageList = [...this.aliImageList, ...res.data.file_list.data.map(item => {
                        return {
                            "id": item.id,
                            "food_url": item.food_url,
                            "food_name": item.food_name,
                            "keyword": item.keyword,
                            "selected": false,
                        };
                    })];
                } else {
                    this.aliImageList = res.data.file_list.data.map(item => {
                        return {
                            "id": item.id,
                            "food_url": item.food_url,
                            "food_name": item.food_name,
                            "keyword": item.keyword,
                            "selected": false,
                        };
                    });
                }
            }).catch(error => {
            });
        },

        loadMore() {
            var scrollHeight = event.target.scrollHeight;
            var scrollTop = event.target.scrollTop;
            var clientHeight = event.target.clientHeight;

            if (scrollTop + clientHeight >= scrollHeight) {
                // 如果已滚动到底部，加载更多图片
                this.fetchMoreImages();
            }
        },
        // 菜品名称非空校验
        validateProductName() {
            if (!this.form.model.product_name) {
                return
            }
            const param = {
                product_name: this.form.model.product_name,
                product_type: this.product_type
            }
            PorductApi.validate_product_name(param, true).then(res => {
                if (res.code === 1 && res.msg === '该菜品已存在') {
                    this.$message.warning(res.msg)
                    this.form.model.product_name = ''
                } else {
                    this.ai_search = this.form.model.product_name
                    this.isShowAiSearch = true
                    this.getAiImageList(1)
                }
            })
        },
        // 所属分类展示
        categoryLabel() {
            this.categoryList = this.formData.category.map(item => {
                let category, name;
                if (item.lang && item.lang.category) {
                    category = JSON.parse(item.lang.category)
                }
                if (category) {
                    const key = this.activeName
                    name = category[key] || item.name
                } else {
                    name = item.name
                }
                return {
                    category_id: item.category_id,
                    name: name
                }
            })
        },
        toggleWenHao() {
            this.isShowWenHao = !this.isShowWenHao;
        },
        handleScroll() {
            this.isShowWenHao = false;
        },
        getTagAction() {
            let self = this;
            if (self.form.model.product_name.length == 0) {
                this.$message({
                    type: 'info',
                    message: self.$t( '请输入菜品名称！')
                });
                return;
            }
            this.getTagLoading = true
            PorductApi.dishInformation_tag(self.form.model.product_name, {}, true).then(res => {
                this.getTagLoading = false
                let tagArr = res.data.response
                //菜品标签
                this.form.model.tag = JSON.parse(tagArr);
                this.selectedOptions = this.form.model.tag
                this.form.model.product_tag = []
                if (Array.isArray(this.selectedOptions) && this.selectedOptions.length > 0) {
                    for (let item of this.selectedOptions) {
                        this.form.model.product_tag.push({
                            tag_name: item,
                            sort: 1,
                        });
                    }
                }
            }
            ).catch(error => {
                this.getTagLoading = false
                console.log("获取标签出错了")
            });
        },
        onDishInformation() {
            let self = this;
            if (self.form.model.product_name.length == 0) {
                this.$message({
                    type: 'info',
                    message: self.$t('请输入菜品名称！')
                });
                return;
            }

            self.loading = true;
            PorductApi.dishInformation_tag(self.form.model.product_name, {}, true).then(res => {
                let tagArr = res.data.response
                //菜品标签
                this.form.model.tag = JSON.parse(tagArr);
                this.selectedOptions = this.form.model.tag
                if (Array.isArray(this.selectedOptions) && this.selectedOptions.length > 0) {
                    for (let item of this.selectedOptions) {
                        this.form.model.product_tag.push({
                            tag_name: item,
                            sort: 1,
                        });
                    }
                }
            }
            )
            PorductApi.dishInformation(self.form.model.product_name, {}, true).then(res => {
                self.loading = false;

                const params = JSON.parse(res.data.response)
                console.log("params", params);
                //基本信息

                self.form.model.taste = params.tasted;//口味

                //所属分类
                for (let item of this.formData.category) {
                    // 在这里对每个选项执行需要的操作
                    if (item.name == params.tasted) {
                        self.form.model.category_id = item.category_id; //所属分类
                        console.log("所属分类" + item.category_id);
                        break;
                    }
                    // console.log(item);
                }
                //介绍
                if (self.form.model.selling_point.length == 0) {
                    self.form.model.selling_point = params.feature;
                }

                //菜品配料
                this.form.model.ingredient = [];

                console.log("params.ingredients", params.ingredients);
                if (Array.isArray(params.ingredients) && params.ingredients.length > 0) {
                    console.log("params.ingredients true");
                    for (let item of params.ingredients) {

                        console.log("params.ingredients item", item);

                        this.form.model.ingredient.push({
                            ingredient_name: item,
                            sort: 1,
                        });
                    }
                }

                //规格库存
                self.form.model.deduct_stock_type = 10; //扣减库存方式 "10">下单减库存 20">付款减库存
                self.form.model.product_unit = "份" //菜品单位
                self.form.model.spec_type = 10;
                self.form.model.product_price = "1"; //菜品价格

                // self.form.model.sku[0].product_price = "1";
                // self.form.model.sku[0].stock_num = "999";
                // self.form.model.sku[0].bag_price = "1";
                // self.form.model.sku[0].product_weight = "3";

                self.form.model.stock_num = "999"; //库存数量

                //菜品属性
                // self.form.model.product_attr = [{
                //     "attribute_name": "温度",
                //     "attribute_value": params.temperature
                // }];
                //加料
                // self.form.model.product_feed = [{"feed_name":"测试料","price":"1"}]; //菜品加料

                //菜品详情
                if (self.form.model.content.length == 0) {
                    self.form.model.content = "<p>" + params.description + "</p>";
                }

                //积分
                self.form.model.is_points_gift = 0;

                //初始销量
                self.form.model.sales_initial = "0";
                //限购数量
                self.form.model.limit_num = 0;
                //菜品排序
                self.form.model.product_sort = 100;

                //会员折扣
                self.form.model.is_enable_grade = 0; //是否开启会员折扣 1开启

                self.form.model.is_alone_grade = 0; // 0默认折扣  1单独设置折扣


                // self.$message({
                //     message: '补全成功',
                //     type: 'success'
                // });
            }).catch(error => {
                self.loading = false;
            });


        },

        //菜品卖点换一换
        onSellingPoint() {
            let self = this;
            self.selling_point_loading = true;
            PorductApi.dishInformation_featrue(self.form.model.product_name, {}, true).then(res => {
                self.selling_point_loading = false;
                //菜品卖点
                self.form.model.selling_point = res.data.response;
            }).catch(error => {
                self.selling_point_loading = false;
            });
        },
        deleteImg(index) {
            this.form.model.image.splice(index, 1);
        },
        openProductUpload() {
            this.isProductUpload = true;
            this.isShowAiSearch = false;
        },
        openAiBox() {
            this.isShowAiSearch = !this.isShowAiSearch;
        },
        returnProductImgsFunc(e) {
            if (e != null) {
                let imgs = e || '';
                // let imgs = this.form.model.image.concat(e) || '';
                this.$set(this.form.model, 'image', imgs);
            }
            this.isProductUpload = false;
        },
        addItem() {
            this.form.model.ingredient.push({
                app_id: this.form.model.app_id,
                product_id: this.form.model.product_id,
                ingredient_id: 0,
                ingredient_name: '',
                sort: 1
            });
        },
        removeItem(index) {
            this.ingredient.splice(index, 1);
        },
        deleteItem(_text) {
            const indexToRemove = this.form.model.ingredient.findIndex(item => item.ingredient_name === _text);
            if (indexToRemove !== -1) {
                this.form.model.ingredient.splice(indexToRemove, 1);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    async mounted() {
        document.addEventListener('click', (event) => {
            const targetElement = event.target;
            const wenHaoBox = this.$el.querySelector('.wenhao-box');
            if (!wenHaoBox.contains(targetElement)) {
                this.isShowWenHao = false;
            }
        });
        window.addEventListener('scroll', this.handleScroll);
    }
};
</script>
<style scoped lang="scss">
.ai-image-container {
    width: 80%;
    margin-top: -15px;
    margin-bottom: 10px;
    border: 1px solid #dddddd;
    margin-left: 180px;
    min-width: 500px;
}

.title-input-search {
    display: flex;
    justify-content: center;
    align-items: center;
}

.title-input-search .fangdajing {
    font-size: 20px;
    line-height: 40px;
}

.title-input-search .fangdajing:hover {
    cursor: pointer;
}

.title-input-search .ai_search {
    flex: 1;
    margin-right: 2px;
    margin-top: 2px;
    font-size: 14px;
}

.title-input-search .ai-pictures-title {
    flex: 1;
    text-align: center;
    font-size: 24px;
    color: #E6A23C;
    font-weight: 700 !important;
}

.ai-image-list {
    margin-top: 10px;
    margin-left: 10px;
    height: 340px;
    /* 或者你需要的任何高度 */
    overflow-y: auto;
}

.imagelists {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: 280px;
    /* 你可以设置你需要的高度 */
    overflow-y: auto;
    /* 当内容超出高度时显示滚动条 */
}

.aliImageItem {
    width: 110px;
    height: 110px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
}

.aliImageItem img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: contain;
}

.no-have-image {
    display: flex;
    height: 95%;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
        font-weight: bold;
    }
}

.no-have-image p {
    font-size: 18px;
    color: #838383;
}


.draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.yulantu img {
    display: inline-block;
    width: 160px;
    height: 140px;
    border-radius: 8px;
    vertical-align: bottom;
}

.selectedIcon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background: #ff9900;
    z-index: 1;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 5px;
}

.selectedIcon .duigou {
    position: relative;
    top: 0;
    left: 5px;
}

.draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 5px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .uploadfile {
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 5px;
    border-radius: 8px;
    border: 1px solid red;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

.draggable-list .img-select-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #dddddd;
    background-color: #409eff;
    font-size: 15px;
    padding: 5px;
    color: #fff;
    border-radius: 3px;
}

.draggable-list .no-select-image {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
    margin: 140px auto;
}

.draggable-list .no-select-image i {
    color: #409eff;
}

/*.draggable-list .img-select i {*/
/*  color: #409eff;*/
/*}*/
.u7E3HKf {
    margin-right: 15px;
}

.wenhao-box {
    display: inline-block;
    position: relative;
}

.wenhao {
    width: 16px;
    height: 16px;
    border: 1px solid #DCDFE6;
    border-radius: 8px;
    line-height: 14px;
    text-align: center;
    font-size: 15px;
    display: inline-block;
    margin-top: 10px;
    color: #DCDFE6;
}

.wenhao:hover {
    cursor: pointer;
    border: 1px solid #409EFF;
    color: #409EFF;
}

.uiNJkJ4 {
    display: flex;
    justify-content: flex-start;
    width: auto;
}

.uBuIHG1 {
    display: flex;
    justify-content: center;
    width: inherit;
    flex: none;
    flex-direction: row;
    text-align: center;
    cursor: pointer;
    box-sizing: inherit;
    flex-wrap: nowrap;
}

.uFZHTog {
    display: flex;
    flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/takeaway/product/part/Basic.vue